module.exports = __webpack_public_path__ + "media/images/city_img/city_head-33bfcd1f55aaf81e4326e4b5953f6bd3.jpg";